import { render, staticRenderFns } from "./itemTwo.vue?vue&type=template&id=978f2b58"
import script from "./itemTwo.vue?vue&type=script&lang=js"
export * from "./itemTwo.vue?vue&type=script&lang=js"
import style0 from "./itemTwo.vue?vue&type=style&index=0&id=978f2b58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports